import { Company } from 'src/features/companies/companies.types';

export interface DraftCompanyAccount {
  email: string;
  password: string;
}

export enum CompanyAccountRole {
  admin = 'admin',
  accountant = 'accountant',
  engineer = 'engineer',
  observer = 'observer',
  reception = 'reception',
  airpano = 'airpano',
}

export interface CompanyAccount {
  id: string;
  fullname: string;
  role: CompanyAccountRole;
  email: string;
  password: string;
  isActive: boolean;
  disabled: boolean;
  companies: Company[];
}
